import axios from 'axios'

axios.defaults.headers.post['Content-Type'] =
  'application/json;charset=UTF-8'

axios.defaults.transformRequest = function(data, headers) {
  return typeof data === 'object' ? JSON.stringify(data) : data
}

const APP_BASE_API = '/oilmonitor'
// const APP_BASE_API = '/oil-monitor'
/**
 * 登录
 * @param {any} reqParam
 */
export function login(reqParam) {
  return axios.post(APP_BASE_API + '/login/user/doin', reqParam)
}

/**
 * 登出
 * @param {any} reqParam
 */
export function logout() {
  console.log('logout token', sessionStorage.getItem('access_token'))
  return axios.post(APP_BASE_API + '/login/doout')
}

/**
 * 获取首页每日排油量TOP10
 * @param {any} reqParam
 */
export function getRanking(reqParam) {
  return axios.get(APP_BASE_API + '/globalstatistics/doquerytop10')
}

/**
 * 获取终端分布图
 * @param reqParam
 * @returns {AxiosPromise<T>}
 */
export function getTerminalDis(reqParam) {
  return axios.get(APP_BASE_API + '/globalstatistics/terminalDis')
}

/**
 * 餐厅查询
 * @param {any} reqParam
 */
export function searchRestaurant(reqParam) {
  return axios.get(APP_BASE_API + '/restaurantmanage/doquery', { params: reqParam })
}

/**
 * 终端查询
 * @param {any} reqParam
 */
export function searchTerminal(reqParam) {
  return axios.get(APP_BASE_API + '/terminalmanage/doquery', { params: reqParam })
}

/**
 * 添加餐厅
 * @param {any} reqParam
 */
export function addRestaurant(reqParam) {
  return axios.post(APP_BASE_API + '/restaurantmanage/doadd', reqParam)
}

/**
 * 删除餐厅
 * @param {any} reqParam
 */
export function delRestaurant(reqParam) {
  return axios.post(APP_BASE_API + '/restaurantmanage/dodel', reqParam)
}

/**
 * 添加终端
 * @param {any} reqParam
 */
export function addTerminal(reqParam) {
  return axios.post(APP_BASE_API + '/terminalmanage/doadd', reqParam)
}

/**
 * 获取终端型号
 * @param {any} reqParam
 */
export function getTerminalModels(reqParam) {
  return axios.get(APP_BASE_API + '/pub/sel/selmodels', { params: reqParam })
}

/**
 * 获取终端IMEI列表
 * @param {any} reqParam
 */
export function getTerminals(reqParam) {
  return axios.get(APP_BASE_API + '/pub/sel/selterminals', { params: reqParam })
}

/**
 * 获取政府工作人员可关联餐厅列表
 * @param {any} reqParam
 */
export function getRestaurants() {
  return axios.get(APP_BASE_API + '/pub/sel/selrestaurants')
}

/**
 * 获取终端关联餐厅列表
 * @param {any} reqParam
 */
export function fetchRestaurants() {
  return axios.get(APP_BASE_API + '/pub/sel/selnotbelongrests')
}

/**
 * 关联终端
 * @param {any} reqParam
 */
export function relatedTerminal(reqParam) {
  return axios.post(APP_BASE_API + '/restaurantmanage/dobindterminal', reqParam)
}

/**
 * 排油量查询
 * @param {any} reqParam
 */
export function searchDrain(reqParam) {
  return axios.get(APP_BASE_API + '/oilrecord/doqueryformap', { params: reqParam })
}

/**
 * ws
 * @param {any} imei
 */
export function getRealtimeTerminalInfo(imei) {
  // return new WebSocket(`ws://192.168.1.107:18100/terminalinfo/867967029999101`)
  return new WebSocket(`ws://39.106.1.123:18100/terminalinfo/${imei}`)
}

/**
 * 餐厅详情
 * @param {any} reqParam
 */
export function getRestaurantDetail(reqParam) {
  return axios.post(APP_BASE_API + '/restaurantmanage/doquerydetails', reqParam)
}

/**
 * 全局油量统计
 * @param {any} reqParam
 */
export function getTotalDrain() {
  return axios.get(APP_BASE_API + '/globalstatistics/total')
}

/**
 * 获取用户列表
 * @param {any} reqParam
 */
export function getAccountList(reqParam) {
  return axios.get(APP_BASE_API + '/usermanage/doquerywithrole', { params: reqParam })
}

/**
 * 创建用户
 * @param {any} reqParam
 */
export function register(reqParam) {
  return axios.post(APP_BASE_API + '/register/docreate', reqParam)
}

/**
 * 密码重置
 * @param {any} reqParam
 */
export function resetPassword(reqParam) {
  return axios.post(APP_BASE_API + '/usermanage/dochangepwd', reqParam)
}

/**
 * 删除账号
 * @param {any} reqParam
 */
export function deleteAccount(reqParam) {
  return axios.post(APP_BASE_API + '/usermanage/dodel', reqParam)
}

/**
 * 政府管理人员绑定餐厅
 * @param {any} reqParam
 */
export function bindManage(reqParam) {
  return axios.post(APP_BASE_API + '/restaurantmanage/bindmanage', reqParam)
}

/**
 * 30天油量统计
 * @param {any} reqParam
 */
export function getOilChart() {
  return axios.get(APP_BASE_API + '/globalstatistics/oilChart')
}
export function singleTotal(reqParam) {
  return axios.get(APP_BASE_API + '/globalstatistics/singleTotal', { params: reqParam })
}



// WEBPACK FOOTER //
// ./src/store/api.js